import React from "react";
import Routes from './Routes';
import { AuthProvider } from './contexts/AuthContext';
import { RealtimeProvider } from './contexts/RealtimeContext';
import { ThemeProvider } from './contexts/ThemeContext';
import { StripeProvider } from './contexts/StripeContext';
import ErrorBoundary from './components/ErrorBoundary';
import OfflineBadge from './components/OfflineBadge';
import CookieConsentBanner from './components/CookieConsentBanner';
import { messagingService } from './services/messagingService';

// Flush handler: re-sends queued offers when connectivity is restored
async function flushQueuedAction(action) {
  if (action?.type === 'send_offer') {
    const { itemId, sellerId, userId, messageContent } = action?.payload || {};
    if (!itemId || !sellerId || !userId || !messageContent) return;
    const conversationId = await messagingService?.createConversation(userId, sellerId, itemId);
    await messagingService?.sendMessage(conversationId, userId, messageContent);
  }
}

function App() {
  return (
    <ThemeProvider>
      <AuthProvider>
        <RealtimeProvider>
          <StripeProvider>
            <ErrorBoundary>
              <Routes />
              <OfflineBadge flushFn={flushQueuedAction} />
              <CookieConsentBanner />
            </ErrorBoundary>
          </StripeProvider>
        </RealtimeProvider>
      </AuthProvider>
    </ThemeProvider>
  );
}

export default App;